<template>
  <div>
    <DataTable v-if="rates" :value="rates" :paginator="rates.length > 15" :rows="15" contextMenu
      class="bc-rates-table mx-auto w-full max-w-[50rem] sm:whitespace-nowrap">
      <Column class="bc-rates-table__column" field="countryName" :header="$t('global.country')" />
      <Column class="bc-rates-table__column" field="rate" :header="$t('global.rate')">
        <template #body="{ data }"> {{ typeof data.rate === 'number' ? data.rate.toFixed(4) : (data.rate || '-') }} € </template>
      </Column>
      <Column class="bc-rates-table__column" field="mmf" :header="$t('components.bmDefaultRates.mmf')">
        <template #body="{ data }"> {{ typeof data.mmf === 'number' ? data.mmf.toFixed(2) : (data.mmf || '-') }} € </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup lang="ts">
import DataTable from "primevue/datatable";
import Column from "primevue/column";
const props = defineProps<{
    filterCountry?: string
}>()

const mockRates: any[] = [
  { countryName: "Other countries", rate: 0.015, mmf: 115 }
];
const filterCountryRef = toRef(props, 'filterCountry');
const { rates } = useRatesTable('/rate/business_call/default', mockRates, filterCountryRef);
</script>

<style lang="scss">
.bc-rates-table {
  width: 100%;

  & thead tr th:not(:first-child) div {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
  }

  &__column:first-child {
    text-align: left;

    & .p-column-header-content {
      justify-content: flex-start;
    }
  }

  &__column {
    text-align: right;

    & .p-column-header-content {
      display: flex;
      justify-content: flex-end;
    }
  }

  & .p-datatable-tbody {
    padding-top: 10px;
  }
}
</style>
